module.exports = __webpack_public_path__ + "images/startBerufsleben.png?668178533e3c32ed11a47ed9f6d808e7";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/startBerufsleben.png
// module id = UMcT
// module chunks = 0